import { render, staticRenderFns } from "./CarouselGames.vue?vue&type=template&id=2d92d936&scoped=true&"
import script from "./CarouselGames.vue?vue&type=script&lang=js&"
export * from "./CarouselGames.vue?vue&type=script&lang=js&"
import style0 from "./CarouselGames.vue?vue&type=style&index=0&id=2d92d936&scoped=true&lang=scss&"
import style1 from "./CarouselGames.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d92d936",
  null
  
)

export default component.exports